import React from 'react';
import { Link, Outlet, RouteObject } from 'react-router';

import { formatter, lang, url } from 'helpers';
import { DashboardPage, InvoicePage, InvoicesPage, ProfilePage, WithdrawalPage } from 'pages';
import { PrivateRoute } from 'components/routes';
import { Invoice } from 'types/models';

import { invoiceLoader } from './loaders';

const privateRoutes: RouteObject[] = [{
  path: url.toDashboard(),
  element: (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  ),
  handle: {
    crumb: () => (
      <Link to={url.toDashboard()}>
        {lang.get('common.menu.dashboard')}
      </Link>
    ),
  },
  children: [
    {
      index: true,
      element: <DashboardPage />,
    }, {
      path: url.toInvoices(),
      handle: {
        crumb: () => (
          <Link to={url.toInvoices()}>
            {lang.get('common.menu.invoices')}
          </Link>
        ),
      },
      children: [
        {
          index: true,
          element: <InvoicesPage />,
        }, {
          path: url.toInvoice(':invoiceId'),
          element: <InvoicePage />,
          loader: ({ params }) => invoiceLoader(params.invoiceId),
          handle: {
            crumb: (invoice: Invoice) => (
              <Link to={url.toInvoice(invoice.id)}>
                {formatter.formatId(invoice.displayId)}
              </Link>
            ),
          },
        },
      ],
    }, {
      path: url.toProfile(),
      element: <ProfilePage />,
      handle: {
        crumb: () => (
          <Link to={url.toProfile()}>
            {lang.get('common.menu.profile')}
          </Link>
        ),
      },
    }, {
      path: url.toWithdrawal(),
      element: <WithdrawalPage />,
      handle: {
        crumb: () => (
          <Link to={url.toWithdrawal()}>
            {lang.get('common.menu.withdrawal')}
          </Link>
        ),
      },
    },
  ],
}];

export default privateRoutes;
